import { createServiceType } from '@tv2-player/service-container/src/serviceContainer';

interface PlatformMetadataServiceType {
  platform: 'web' | 'smarttv' | 'cast';
}
export const PlatformMetadataService = createServiceType<PlatformMetadataServiceType>();
